import styled from 'styled-components';
import { HStack } from '../../Core';

/**
 * Root layout for a custom AG Grid column-group (e.g. Price Grid's Market Data column group) header that includes
 * {@link AgGridHeaderGroupMenuButton}.
 *
 * The menu button defaults to collapsed (`opacity: 0`, `flex-basis: 1px`). This root:
 * - spans the full group header width so content/actions can use `ml="auto"` layout
 * - reveals the `.ag-header-group-menu-button` on hover / focus-within
 *
 * Active / menu-open reveal is handled separately on the button and in BlotterTable styles
 * (`.ag-header-active`, `.ag-column-menu-visible`). Consumers should also set
 * `className="ag-header-group-inner-header-root"` so BlotterTable can force
 * `.ag-header-group-text` to full width via `:has(...)`.
 */
export const AgGridHeaderGroupInnerHeaderRoot = styled(HStack)`
  width: 100%;

  &:hover,
  &:focus-within {
    .ag-header-group-menu-button {
      flex-basis: var(--ag-icon-size, 16px);
      opacity: 1;
      transition:
        flex-basis 200ms ease,
        opacity 200ms ease;
    }
  }
`;
